import {withRoles} from '../hocs/roles/withRoles';
import IntegrityGrid from './IntegrityGrid';

export default withRoles(IntegrityGrid);
